import AutoCompleteDropdown from "../../../../../ui library/components/dropdowns/AutoCompleteDropdown";
import CustomIconButton from "../../../../../ui library/components/buttons/CustomIconButton";
import { CalendarMonth, Delete } from "@mui/icons-material";
import { DesktopDateTimePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

import setHours from "date-fns/setHours";
import setMinutes from "date-fns/setMinutes";
import { useUploadDocumentStore } from "../../hooks/useUploadDocumentStore";

const BillAccordionSummary = ({ accordionItem }) => {
  const { provider } = useUploadDocumentStore();

  const handleDateChange = (newDate) => {
    if (!newDate) return;
    if (!accordionItem.scheduled) {
      const withNoon = setMinutes(setHours(newDate, 12), 0);
      accordionItem.updateScheduled(accordionItem.id, withNoon);
    } else {
      accordionItem.updateScheduled(accordionItem.id, newDate);
    }
  };

  const providerTypeOptions =
    provider?.providerTypes?.map((type, index) => ({
      id: type.id,
      label: type.name,
    })) || [];

  return (
    <div className="w-full flex-flex-col">
      <div className="flex flex-row w-full items-center">
        <div className="w-1/2 p-2">
          <AutoCompleteDropdown
            initValue={null}
            label="Provider Type"
            data={providerTypeOptions}
            onValueChange={(e, value) =>
              accordionItem.updateProviderTypeId(accordionItem.id, value)
            }
          />
        </div>
        <div className="w-1/2 p-2">
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DesktopDateTimePicker
              value={
                accordionItem.scheduled ||
                new Date(new Date().setHours(12, 0, 0, 0))
              }
              onChange={handleDateChange}
              components={{
                OpenPickerIcon: CalendarMonth,
              }}
              slotProps={{
                inputAdornment: {
                  position: "end",
                },
              }}
              label="Appointment Date"
              name="startDateTime"
              className="w-full"
            />
          </LocalizationProvider>
        </div>
        <div>
          <CustomIconButton
            classes={"p-2"}
            iconVisible={true}
            CustomIcon={<Delete className="text-red-500" />}
            handleOnClick={() => accordionItem.deleteRow(accordionItem.id)}
          />
        </div>
      </div>
    </div>
  );
};

export default BillAccordionSummary;
